import React from 'react';
import { CmhcIcon, CmhcIconSize } from '@cmhc-schl/hearth-ui';
import { Box, IconButton, Typography } from '@mui/material';
import {
  getPortfolioLoanStatusName,
  getPortfolioLoanStatusDisplayName
} from 'Feature/V2/HbtPortfolioManagement/utils/loanStatusMapping';
import { useTranslation } from 'react-i18next';
import { LoanInventoryTableFields } from '../../HbtPortfolioLoansInventoryTable/types';
import styles from './style.module.scss';

interface FlyoutLoanItemProps {
  loan: LoanInventoryTableFields;
  removeItem: (item: LoanInventoryTableFields) => void;
  loanNumber: string;
  loanStatus: string;
  error: boolean;
  showIconButton?: boolean;
  hoverEnabled?: boolean;
}

export const FlyoutLoanItem = ({
  loanNumber,
  loanStatus,
  error,
  loan,
  removeItem,
  showIconButton = true,
  hoverEnabled = true
}: FlyoutLoanItemProps) => {
  const { t } = useTranslation('HbtPortfolioManagementRequestOverview');

  const status = getPortfolioLoanStatusDisplayName(getPortfolioLoanStatusName(loanStatus), t) || '';
  return (
    <Box
      className={`${styles.selectedLoan} ${hoverEnabled && styles.hoverState} ${
        error && styles.loanError
      }`}
    >
      <Box className={styles.selectedLoanStatus}>
        <Typography className={styles.loanNumber}>{loanNumber}</Typography>
        <Typography className={styles.loanStatusContainer}>
          <div
            className={`${styles.validationResultsStatus} ${styles[`status${loanStatus}`]}`}
          ></div>
          {status}
        </Typography>
      </Box>
      <Box className={styles.iconContainer}>
        {error && (
          <CmhcIcon
            size={CmhcIconSize.SMALL}
            className={styles.errorIcon}
            type="icon_error_outlined"
          />
        )}
        {showIconButton && (
          <IconButton
            aria-label={t('PI-Portfolio-Overview-Flyout-Remove-Loan')}
            size="medium"
            onClick={() => removeItem(loan)}
          >
            <CmhcIcon size={CmhcIconSize.SMALL} type="icon_close" className={styles.closeIcon} />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};
